import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { TICKET_PRIORITIES } from "../constants";
import { getLocalStorage } from "../utils/storageUtils";
import FormResponseItem from "./common/FormResponseItem";

interface FormValuesBackup {
  priority: string;
  text: string;
  type: string;
}

const BugReportConfirmationView = () => {
  const storage = getLocalStorage();
  const formValuesBackup = storage?.formValuesBackup as
    | FormValuesBackup
    | undefined;

  if (!formValuesBackup) {
    return (
      <div>{t("support_widget_v2.send_message_form.something_went_wrong")}</div>
    );
  }

  const priorityText =
    TICKET_PRIORITIES.find(p => p.value === formValuesBackup.priority)?.text ||
    TICKET_PRIORITIES[0].text;

  return (
    <div className="p-4">
      <div className="my-6 flex flex-col items-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-500">
          <Icon type="36-check" size={36} className="text-white" />
        </div>
        <div className="mt-2 text-center">
          <Typography.TitleMd weight="bold">
            {t("support_widget_v2.send_message_form.message_sent_successfully")}
          </Typography.TitleMd>
        </div>
        <div className="mt-2 text-center">
          <Typography.BodySm color="text-tertiary">
            {t("support_widget_v2.send_message_form.notify_message")}
          </Typography.BodySm>
        </div>
      </div>

      <FormResponseItem
        question={t("support_widget_v2.send_message_form.type")}
        answer={formValuesBackup.type}
      />
      <FormResponseItem
        question={t("support_widget_v2.send_message_form.priority")}
        answer={priorityText}
      />
      <FormResponseItem
        question={t("support_widget_v2.send_message_form.text")}
        answer={formValuesBackup.text}
      />
    </div>
  );
};

export default BugReportConfirmationView;
